import React, { createContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

const { Consumer: TranslatorConsumer, Provider: TranslatorProvider } =
  createContext((key) => key);

/**
 * HOC that wraps a component with a TranslatorConsumer, ensuring that the
 * translator function is passed along as a prop.
 */
export const withTranslator = (PassedComponent) => {
  function Component(props) {
    return (
      <TranslatorConsumer>
        {(translator) => <PassedComponent {...props} t={translator} />}
      </TranslatorConsumer>
    );
  }

  Component.WrappedComponent = PassedComponent;
  return hoistNonReactStatics(Component, PassedComponent);
};

export const Translator = TranslatorProvider;
